const isSensitive = field => ['description', 'email', 'name', 'phone', 'title'].includes(field);
export default isSensitive;
